import { REACT_APP_AUTH_URL } from "../../../../../constants/env";
import type { IApiClientService } from "../../../../services/ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../../services/AxiosApiClientInstance/AxiosApiClientInstance";
import type { ExternalLoginTokenExchangeDTO } from "../dto/token-exchange.dto";
import type { IExternalLoginDatasource } from "./external-login.datasource.interface";

export class ExternalLoginDatasource implements IExternalLoginDatasource {
  private readonly _EXCHANGE_TOKEN_URL = "/auth/api/v2/sso/exchange-token";

  constructor(
    private readonly _client: IApiClientService = new AxiosApiClientInstance({
      baseURL: REACT_APP_AUTH_URL as string,
    })
  ) {}

  public async exchangeNonceToken(authenticationToken: string): Promise<ExternalLoginTokenExchangeDTO> {
    const payload = { authenticationToken };

    const { data } = await this._client.post<{ authenticationToken: string }, ExternalLoginTokenExchangeDTO>(
      this._EXCHANGE_TOKEN_URL,
      payload
    );

    if (!data) {
      throw new Error("Failed to exchange nonce authenticationToken: no response data.");
    }

    return data;
  }
}
